import { Navigate } from 'react-router-dom';

import Profile from './views/profile/profile';
import EditPassword from './views/profile/edit-password/edit-password';
import ManageAddresses from './views/addresses/addresses';
import AddAddress from './views/addresses/add-address/add-address';
import EditAddress from './views/addresses/edit-address/edit-address';
import Orders from './views/orders/orders';
import ViewOrder from './views/orders/view-order/view-order';
import Login from './views/account-management/login/login';
import Logout from './views/account-management/logout/logout';
import Signup from './views/account-management/signup/signup';
import ResetPassword from './views/account-management/reset-password/reset-password';
import ConfirmSignup from './views/account-management/confirm-signup/confirm-signup';
import PageNotFound from './views/404/page-not-found';
import UserManagement from './views/user-management/user-management';

export const routes = [
  {
    path: '/',
    main: <Navigate to="/orders" />,
  },
  {
    path: '/account',
    main: <Navigate to="/orders" />,
  },
  {
    path: '/logout',
    main: <Logout />,
  },
  {
    path: '/profile',
    main: <Profile />,
  },
  {
    path: '/profile/edit-password',
    main: <EditPassword />,
  },
  {
    path: '/addresses',
    main: <ManageAddresses />,
  },
  {
    path: '/addresses/add',
    main: <AddAddress />,
  },
  {
    path: '/addresses/edit',
    main: <EditAddress />,
  },
  {
    path: '/orders',
    main: <Orders />,
  },
  {
    path: '/orders/view-order',
    main: <ViewOrder />,
  },
  {
    path: '/page-not-found',
    main: <PageNotFound />,
  },
  {
    path: '*',
    main: <Navigate to="/orders" />,
  },
];

export const loginRoutes = [
  {
    path: '/account',
    main: <Navigate to="/login" />,
  },
  {
    path: '/login',
    main: <Login />,
  },
  {
    path: '/signup',
    main: <Signup />,
  },
  {
    path: '/reset-password',
    main: <ResetPassword />,
  },
  {
    path: '/confirm-signup',
    main: <ConfirmSignup />,
  },
  {
    path: '/cs',
    main: <UserManagement />,
  },
  {
    path: '*',
    main: <Navigate to="/login" />,
  },
];
